module.exports = __webpack_public_path__ + "static/media/p_19_0.75f62c72.png";